(function () {
  var nps = null, zuf = '', freiWert = '';
  function init() {
    var form = document.getElementById('ys-zuf-form');
    if (!form) return;
    var st = document.getElementById('ys-zuf-status');
    var zusatzBox = document.getElementById('ys-zuf-zusatzbox');
    var zusatzFrage = document.getElementById('ys-zuf-zusatzfrage');
    var rueckBox = document.getElementById('ys-zuf-rueckbox');

    Array.prototype.forEach.call(document.querySelectorAll('.ys-zuf-note'), function (b) {
      b.addEventListener('click', function () {
        nps = parseInt(b.dataset.wert, 10);
        Array.prototype.forEach.call(document.querySelectorAll('.ys-zuf-note'), function (x) {
          x.classList.remove('ys-zuf-aktiv');
        });
        b.classList.add('ys-zuf-aktiv');
        zusatzBox.style.display = 'block';
        var fb = document.getElementById('ys-zuf-freibox');
        if (fb) { fb.style.display = 'block'; }
        if (nps >= 9) {
          zusatzFrage.textContent = 'Schön zu hören. Was gefällt dir bei uns am besten?'; var zf = document.getElementById('ys-zuf-zusatz'); if (zf) zf.placeholder = 'Zum Beispiel: der Duft, wie gut deine Kopfhaut es verträgt, die natürlichen Inhaltsstoffe, die Beratung …';
          rueckBox.style.display = 'none';
        } else if (nps >= 7) { var zf2 = document.getElementById('ys-zuf-zusatz'); if (zf2) zf2.placeholder = 'Deine Antwort …';
          zusatzFrage.textContent = 'Was würde aus einer guten eine sehr gute Erfahrung machen?';
          rueckBox.style.display = 'none';
        } else { var zf3 = document.getElementById('ys-zuf-zusatz'); if (zf3) zf3.placeholder = 'Deine Antwort …';
          zusatzFrage.textContent = 'Das tut uns leid. Was ist schiefgelaufen?';
          rueckBox.style.display = 'block';
        }
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('.ys-zuf-stufe'), function (b) {
      b.addEventListener('click', function () {
        zuf = b.dataset.wert;
        Array.prototype.forEach.call(document.querySelectorAll('.ys-zuf-stufe'), function (x) {
          x.classList.remove('ys-zuf-aktiv');
        });
        b.classList.add('ys-zuf-aktiv');
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('.ys-zuf-frei'), function (b) {
      b.addEventListener('click', function () {
        freiWert = b.dataset.wert;
        Array.prototype.forEach.call(document.querySelectorAll('.ys-zuf-frei'), function (x) {
          x.classList.remove('ys-zuf-aktiv');
        });
        b.classList.add('ys-zuf-aktiv');
      });
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (nps === null) {
        st.style.display = 'block';
        st.textContent = 'Bitte wähle zuerst eine Zahl von 0 bis 10.';
        return;
      }
      var knopf = document.getElementById('ys-zuf-senden');
      knopf.disabled = true;
      st.style.display = 'none';
      var rueck = document.getElementById('ys-zuf-rueckruf');
      fetch('https://yelasai.ai/api/zufriedenheit.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: form.dataset.email, name: form.dataset.name, nps: nps,
          zufriedenheit: zuf,
          text: document.getElementById('ys-zuf-text').value,
          zusatz: document.getElementById('ys-zuf-zusatz').value,
          rueckruf: rueck && rueck.checked && rueckBox.style.display !== 'none',
          veroeffentlichen: freiWert
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('Fehler');
        return r.json();
      }).then(function (d) {
        var v = form.dataset.vorname || '';
        var txt = d && d.bereits_beantwortet
          ? 'Du hast uns dieses Jahr schon geantwortet — dafür nochmals danke. Wir fragen dich frühestens in einem Jahr wieder.'
          : (nps <= 6
              ? 'Danke für deine Offenheit. Gerade kritische Rückmeldungen helfen uns am meisten weiter.'
              : 'Danke, dass du dir die Zeit genommen hast. Deine Antwort geht direkt zu uns.');
        document.getElementById('ys-zuf-karte').innerHTML =
          '<h2 class="ys-zuf-danke">Danke' + (v ? ', ' + v : '') + '!</h2>' +
          '<p class="ys-zuf-dankezeile">' + txt + '</p>';
      }).catch(function () {
        knopf.disabled = false;
        st.style.display = 'block';
        st.textContent = 'Das hat leider nicht geklappt. Bitte versuche es gleich noch einmal.';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
